import React, { Component, Fragment } from "react"
import { Redirect } from "react-router-dom"
import { Container, Row, Col, CardBody, Card, CardTitle, Button, FormGroup, Label, Input } from "reactstrap"
import { ConfirmAlert } from "../../../../helpers/ui/alert"
import { accessRole } from "../../../../helpers/access_role"
import CreateBloc from './Blocs/CreateBloc'
import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/master/templateSuratService.jsx'
import { AvForm, AvField } from "availity-reactstrap-validation"
import { FileInput } from "../../../../helpers/ui/FileInput"

class CreateView extends Component {
    createBloc = new CreateBloc()
    source

    constructor(props) {
        super(props)
        this.state = {
            namaTemplate: "",
            jenisSurat: "",
            fileTemplate: null,
            loading: false,
            success: false,
            failed: false,
            confirm: false,
            redirect: false,
            dataForm: null,
            errors: {},
            uploadDocumentType: "file_surat_keterangan_anak"
        }
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel()
        }
        this.source = cancelToken()
    }

    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm, this.source.token)
    }

    handleSubmit = (event, values) => {
        event.preventDefault()
        console.log('handleSubmit values:', values)

        const formData = new FormData()
        formData.append('nama_template', values.nama_template)
        formData.append('jenis_surat', values.jenis_surat)
        formData.append('template_surat_type', values.template_surat_type)
        if (values.file_doc && values.file_doc.length > 0) {
            formData.append('file_template', values.file_doc[0])
        }

        this.setState({ dataForm: formData, confirm: true, errors: {} })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = { confirm: false }
                break
            case 'confirm':
                forState = { loading: true, confirm: false }
                this.submitData()
                break
            case 'success':
                forState = { success: false, redirect: true }
                break
            case 'failed':
                forState = { failed: false }
                break
            default:
        }
        this.setState(forState)
    }

    componentDidMount() {
        if (!accessRole('create')) {
            this.setState({ redirect: true })
        }

        this.setTokenAPI()

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true
                    })
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                        errors: { submit: result.data.message || 'Gagal membuat template surat' }
                    })
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.createBloc.createChannel.unsubscribe()
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to="/master/template-surat.html" />
        }

        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <CardTitle className="mb-4">Tambah Template Surat</CardTitle>

                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={this.handleSubmit}
                                    >
                                        <Row>
                                            <Col md="4">
                                                <FormGroup>
                                                    <Label for="namaTemplate">Nama Template <span className="text-danger">*</span></Label>
                                                    <AvField
                                                        type="text"
                                                        name="nama_template"
                                                        id="namaTemplate"
                                                        placeholder="Masukkan nama template"
                                                        validate={{ required: { value: true, errorMessage: "Nama template harus diisi" } }}
                                                        disabled={this.state.loading}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md="4">
                                                <FormGroup>
                                                    <Label for="jenisSurat">Jenis Surat <span className="text-danger">*</span></Label>
                                                    <AvField
                                                        type="select"
                                                        name="jenis_surat"
                                                        id="jenisSurat"
                                                        className="form-control"
                                                        value={this.state.uploadDocumentType || ""}
                                                        onChange={(e) => {
                                                            this.setState({
                                                                uploadDocumentType: e.target.value || null,
                                                            })
                                                        }}
                                                        disabled={this.state.loading}
                                                        validate={{ required: { value: true, errorMessage: "Jenis surat harus diisi" } }}
                                                    >
                                                        <option value="">Pilih Jenis Surat</option>
                                                        <option value="file_surat_keterangan_anak">Surat Keterangan Anak</option>
                                                    </AvField>
                                                    <AvField
                                                        name="template_surat_type"
                                                        id="template_surat_type"
                                                        value="6876f182-b207-4d04-b8e4-f3008b9b4577"
                                                        type="hidden"
                                                    // validate={{ required: { value: true, errorMessage: "Jenis surat harus diisi" } }}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md="4">
                                                <FormGroup>
                                                    <Label for="fileTemplate">Upload Template Surat <span className="text-danger">*</span></Label>
                                                    <FileInput
                                                        name="file_doc"
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <div className="mt-4">
                                            <Button
                                                color="primary"
                                                type="submit"
                                                disabled={this.state.loading}
                                            >
                                                Simpan
                                            </Button>
                                            <Button
                                                color="secondary"
                                                type="button"
                                                onClick={() => this.setState({ redirect: true })}
                                                disabled={this.state.loading}
                                                className="ms-2"
                                            >
                                                Batal
                                            </Button>
                                        </div>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />
            </Fragment>
        )
    }
}

export default CreateView
